<template>
    <div>
      <Toolbar
        :handle-reset="resetForm"
        :handle-submit="onCreateSubscription"
      />
      <SubscriptionForm
        :errors="violations"
        :values="item"
        ref="createForm"
        refForm="createForm"
        :loading="isLoading"
      />
      <Loading :visible="isLoading" />
    </div>
  </template>

  <script>
    import { mapActions } from 'vuex';
    import { createHelpers } from 'vuex-map-fields';
    import SubscriptionForm from '../../components/subscription/Form.vue';
    import Loading from '../../components/Loading';
    import Toolbar from '../../components/Toolbar';
    import CreateMixin from '../../mixins/CreateMixin';
    import SubscriptionMixin from '@/mixins/SubscriptionMixin';

    import { mapGetters } from 'vuex';

    const servicePrefix = 'Subscription';

    const { mapFields } = createHelpers({
      getterType: 'subscription/getField',
      mutationType: 'subscription/updateField'
    });

    export default {
      name: 'SubscriptionUpdate',
      servicePrefix,
      mixins: [CreateMixin, SubscriptionMixin],
      components: {
        Loading,
        Toolbar,
        SubscriptionForm,
      },
      data() {
        return {
          item: {
            seminars: [],
          },
        };
      },
      computed: {
        ...mapFields(['error', 'isLoading', 'created', 'deleted', 'violations', 'handled', 'handleAction']),
        ...mapFields('subscription', {
        }),
        ...mapGetters('subscription', ['find']),
      },
      methods: {
        ...mapActions('subscription', {
          create: 'create',
          retrieve: 'load',
          update: "update",
          deleteItem: 'del',
        }),
        onCreateSubscription() {
          if (this.$route.params.parent) {
            this.$refs.createForm.item.parent = this.$route.params.parent;
          }
          this.onSendForm();
        },
        editHandler(item) {
          this.retrieve(item['@id']).then(() => {
            this.$router.push({
              name: `${this.$options.servicePrefix}Update`,
              params: { id: item['@id'] }
            });
          });
        },
        deleteHandler(item) {
          this.deleteItem(item);
        },
        deleteWatcher(deleted) {
          if (!deleted) {
            return;
          }
          this.showMessage(this.deleteMessage);
          this.retrieve(deleted.parent);
        }
      },
      created() {
        this.parent = this.$route.params.parent ? this.find(this.$route.params.parent) : {};
      },

      beforeRouteUpdate(to, from, next) {
        if (to.params.id !== from.params.id) {
          this.loadObjectToUpdate().then(() => this.doResetForm());
        }
        next();
      }
    };
  </script>
